import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { PROJECT_COMPLETION__SUB_VIEWS } from 'sh-www/constants/routes/project-completion';
import { trackPageViewFromTransition } from 'sh-www/utils/datalayer';

class ProjectAdvanceApproveRoute extends Route {
  @service('states/routes/project-completion') state;
  @service('state-managers/routes/project-completion') stateManager;
  @service session;

  /** @inheritDoc */
  beforeModel() {
    this.stateManager.setIsAdvancePayment(true);
    this.set('state.isApprovingAdvance', true);
  }

  model() {
    if (this.session.currentUser.isBuyer) {
      this.stateManager.setTestBillingRecord(this.state.application.advanceShInvoiceNeedsAgreement);
      this.set('state.approvingAdvanceBillingRecord', this.state.application.advanceShInvoiceNeedsAgreement);
    } else {
      this.stateManager.setTestBillingRecord(this.state.application.advanceShPaymentNeedsAgreement);
      this.set('state.approvingAdvanceBillingRecord', this.state.application.advanceShPaymentNeedsAgreement);
    }
  }

  /** @inheritDoc */
  activate(transition) {
    super.activate(...arguments);

    this.controllerFor('application').setProperties({
      isShowSimpleHeader: true,
      simpleHeaderText: 'Review Advance',
      simpleHeaderRightText: 'Cancel',
      simpleHeaderRightAction: () => {
        this.stateManager.handleCancelClicked();
      }
    });

    this.stateManager.setSubView(PROJECT_COMPLETION__SUB_VIEWS.NONE);
    trackPageViewFromTransition(this, transition, '/project-advance/:id/approve/');
  }

  /** @inheritDoc */
  deactivate() {
    super.deactivate(...arguments);

    this.controllerFor('application').setProperties({
      isShowSimpleHeader: false,
      simpleHeaderText: '',
      simpleHeaderRightText: '',
      simpleHeaderRightAction: null
    });
  }
}

export default ProjectAdvanceApproveRoute;
